import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AddChecklistTodo = graphql.persisted(
  "AddChecklistTodo",
  graphql(`mutation AddChecklistTodo($input: AddChecklistTodoInput!) {
    addChecklistTodo(input: $input) {
      item { id title personName state adHoc officeOnly required }
      errors
    }
  }`)
);

export { AddChecklistTodo };
export function useAddChecklistTodo() {
  return useMutation(AddChecklistTodo);
}
